/**
 * In-memory store for the forgot-password flow.
 * Keeps otp_token and otp_code out of URL params (avoids leaking via referrers/logs on web).
 */
let _otpToken: string | null = null;
let _otpCode: string | null = null;

export const forgotPasswordStore = {
  setToken: (token: string) => {
    _otpToken = token;
  },
  getToken: () => _otpToken,
  setCode: (code: string) => {
    _otpCode = code;
  },
  getCode: () => _otpCode,
  clear: () => {
    _otpToken = null;
    _otpCode = null;
  },
};
